import '../Sass/App.scss';
import * as React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import featuredImage from '../Images/featured.png';

const BOOT_SEQUENCE = [
    ['01', 'install bootkit', 'Get the physical components you need to start playing. Type "shop bootkits."'],
    ['02', 'collect codebases', 'Discover new code you can deploy against the virus. Type "shop codebases."'],
    ['03', 'review rules', 'Spend five minutes learning how to play. Type "rules."'],
    ['04', 'save the world', 'Defeat escalating threats before they overrun the board.']
];

export class Home extends React.Component {
    runCommand(page, sendId = 0) {
        this.props.changePage(page, sendId);
    }

    render() {
        return (
            <Container className="main-content home-page" maxWidth={'xl'}>
                <Grid container spacing={3}>
                    <Grid xs={12} lg={7}>
                        <section className="home-terminal home-briefing">
                            <div className="home-terminal-bar">
                                <span className="green-code">malware://mission-briefing</span>
                                <span className="grey-code">status: live</span>
                            </div>
                            <p className="home-kicker">incoming transmission <span className="threat-warning">threat detected</span></p>
                            <h1>global outbreak in progress</h1>
                            <p className="home-copy">
                                <i>Malware</i> is a collaborative card game where players (known as developers)
                                band together to defeat world-threatening computer viruses. Choose a Codebase,
                                build a program, and keep fragile systems running while launching your counterattack.
                            </p>
                        </section>
                    </Grid>
                    <Grid xs={12} lg={5}>
                        <aside className="home-terminal home-status">
                            <div className="home-terminal-bar">
                                <span className="green-code">recommended system commands</span>
                            </div>
                            <div className="home-command-list" aria-label="primary commands">
                                <button className="home-command" onClick={() => this.runCommand('rules')}>
                                    <span>&gt;</span> rules
                                </button>
                                <button className="home-command" onClick={() => this.runCommand('shop', 'shop bootkits')}>
                                    <span>&gt;</span> shop bootkits
                                </button>
                                <button className="home-command" onClick={() => this.runCommand('documentation', 0)}>
                                    <span>&gt;</span> documentation
                                </button>
                            </div>
                            <div className="home-alert">
                                <span className="green-code">hint</span>
                                <span className="white-code">start typing anywhere to open the command line</span>
                            </div>
                        </aside>
                    </Grid>
                    <Grid xs={12}>
                        <section className="home-terminal home-preview">
                            <div className="home-terminal-bar">
                                <span className="green-code">./run_playtest --preview</span>
                                <span className="grey-code">feed: gameplay capture</span>
                            </div>
                            <div className="home-preview-grid">
                                <div className="home-preview-media">
                                    <img src={featuredImage} alt="Developers seated at terminals during a Malware game session" />
                                </div>
                                <div className="home-preview-copy">
                                    <h2>see the game in action</h2>
                                    <p>
                                        Developers coordinate their counterattack strategy, deploy cards from their Codebases,
                                        and race to neutralize viruses before the world's systems collapse into chaos.
                                    </p>
                                    <button className="cli-button" onClick={() => this.runCommand('playtest engine', 0)}>
                                        launch playtest
                                    </button>
                                </div>
                            </div>
                        </section>
                    </Grid>
                    <Grid xs={12} md={7}>
                        <section className="home-terminal home-boot-sequence">
                            <div className="home-terminal-bar">
                                <span className="green-code">boot sequence</span>
                                <span className="grey-code">new player path</span>
                            </div>
                            {BOOT_SEQUENCE.map(([step, title, description]) => (
                                <div className="home-sequence-line" key={step}>
                                    <span className="home-sequence-index">{step}</span>
                                    <div>
                                        <h3>{title}</h3>
                                        <p>{description}</p>
                                    </div>
                                </div>
                            ))}
                        </section>
                    </Grid>
                    <Grid xs={12} md={5}>
                        <section className="home-terminal home-developer-mode">
                            <div className="home-terminal-bar">
                                <span className="green-code">developer mode</span>
                                <span className="grey-code">marketplace enabled</span>
                            </div>
                            <h2>build and sell Codebases</h2>
                            <p>
                                Design your own Codebases, publish them, and offer them to other
                                developers through the online marketplace. Create new strategies, test them
                                against viruses, then share the strongest builds with the community.
                            </p>
                            <button className="cli-button" onClick={() => this.runCommand('documentation', 0)}>
                                open codebase docs
                            </button>
                        </section>
                    </Grid>
                </Grid>
            </Container>
        )
    }
}
